import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { UploadFileExtension } from 'packages/manualDataTapeUploads/ui/UploadDataTapeDropzone';
import { UploadDataTapeForm } from 'packages/manualDataTapeUploads/ui/UploadDataTapeForm';
import { FiUpload } from 'react-icons/fi';

type Props = {
  allowedExtensions: UploadFileExtension[];
  buttonText: string;
  modalHeaderText?: string;
  handleFile: (arrayBuffer: ArrayBuffer, fileName: string) => void;
};
export const FileUploadButton = ({
  buttonText,
  modalHeaderText,
  handleFile,
  allowedExtensions,
}: Props) => {
  const [loanTapeUploadLoading, setLoanTapeUploadLoading] = useState(false);
  const [isUploadLoanTapeModalOpen, setIsUploadLoanTapeModalOpen] = useState(
    false,
  );
  const onLoanTapeModalClose = () => setIsUploadLoanTapeModalOpen(false);

  return (
    <Box>
      <Button
        isLoading={loanTapeUploadLoading}
        leftIcon={<FiUpload />}
        variant="outline"
        onClick={() => setIsUploadLoanTapeModalOpen(true)}
      >
        {buttonText}
      </Button>

      <Modal
        isOpen={isUploadLoanTapeModalOpen}
        onClose={onLoanTapeModalClose}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent padding="20px" width="auto" minW="550px">
          <ModalHeader>{modalHeaderText ?? 'Upload Tape'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UploadDataTapeForm
              allowedExtensions={allowedExtensions}
              onClose={onLoanTapeModalClose}
              handleFile={(file: File) => {
                setLoanTapeUploadLoading(true);
                const reader = new FileReader();
                reader.onload = async () => {
                  finleyAssert(
                    reader.result instanceof ArrayBuffer,
                    'reader result is not an ArrayBuffer',
                  );
                  handleFile(reader.result, file.name);
                  setLoanTapeUploadLoading(false);
                };
                reader.readAsArrayBuffer(file);
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
